import React, {useState} from "react";
import {coockieTimeOut, defaultQuota, ordinaryQuota, donationMagazineQuota, defaultMinYoungAge, defaultMinYoungYear, currentAppLocale} from "../config/global";
import CodiceFiscale from "codice-fiscale-js";

import JSONIncaricoIstituzionale from "../../../json/system/incarico_istituzionale.json";
import JSONRegions from '../../../json/databasecomuni/italy_regions.json'
import JSONProvincies from '../../../json/databasecomuni/italy_provincies.json'
import JSONCities from '../../../json/databasecomuni/italy_cities.json'

import moment from 'moment';

export const useToolkit = () => {
    moment.locale(currentAppLocale);

    let logArray = (data: any) => {
        let name;
        let value;
        for(let i=0; i<Object.keys(data).length; i++){

            // Get the name and value of the old object
            name = Object.keys(data)[i];
            value = data[name];

            console.log(name + ': ' + value);
        };
    }
    function getCookieExpiration() {
        let date = new Date();
        date.setTime(date.getTime() + coockieTimeOut);
        return date;
    }
    function getAge(birthday: Date | string){
        //milliseconds in a year 1000*24*60*60*365.24 = 31556736000;
        let today = new Date(),
            //birthay has 'Dec 25 1998'

            dob = new Date(birthday),
            //difference in milliseconds
            diff = today.getTime() - dob.getTime(),
            //convert milliseconds into years
            years = Math.floor(diff / 31556736000),
            //1 day has 86400000 milliseconds
            days_diff= Math.floor((diff % 31556736000) / 86400000),
            //1 month has 30.4167 days
            months = Math.floor(days_diff / 30.4167),
            days = Math.floor(days_diff % 30.4167);

        //console.log(`${years} years ${months} months ${days} days`);
        return {
            years: years,
            months: months,
            days: days
        };
    }

    const getQuota = (field: any, value: any) => {
        let r = '0';
        //console.log('getQuota: field' + field);

        if (field)
        {
            if (field === 'fiscalCode')
            {
                if(value)
                {
                    try {
                        //console.log('getQuota: fiscalCode ' + value);
                        const cf = new CodiceFiscale(value);
                        //console.log(cf.toJSON());
                        
                        r = ordinaryQuota;

                        
                        //var dob = new Date(cf.year, cf.month, cf.day,0,0,0,0);
                        var a = getAge(cf.birthday);
                        //console.log('a: ' + a);

                        //console.log('a.years: ' + a.years);
                        //console.log('a.years <= ' + defaultMinYoungAge + ': ' + (a.years <= defaultMinYoungAge));

                        if((a.years <= defaultMinYoungAge))
                            r = '0';

                        
                        //console.log('cf.year: ' + cf.year);
                        //console.log('cf.year >= ' + defaultMinYoungYear + ': ' + (cf.year >= defaultMinYoungYear));
                        
                        /*
                        let y = new Date().getFullYear()
                        let z = (y - cf.year);
                        
                        console.log('y: ' + y);
                        console.log('cf.year: ' + cf.year);
                        console.log('z: ' + z);
                        console.log('z <= ' + defaultMinYoungAge + ': ' + (z <= defaultMinYoungAge));
                        
                        if(z <= defaultMinYoungAge)
                            r = '0';
                        */

                    } catch (e) {
                        //console.log('getQuota: ' + e);
                    }
                }
            }

            if(field === 'incarico')
            {
                if(value !== 'NONE')
                {
                    const q = JSONIncaricoIstituzionale.incarico_istituzionale
                        .find(i => i.IscrizioneOnLine === 1
                            && i.Tesseramento === 1
                            && i.ID_IncaricoIstituzionale === parseInt(value));

                    if(q)
                        r = q?.QuotaAdesione.toString();
                }
                else
                    r = '0';
            }

            /*
            if(field === 'donationMagazine')
            {
                let q = getCurrentQuote();
                if(value) {
                    r = (parseInt(q) + 10).toString();
                }
                else {
                    if(q != '0')
                        r = (parseInt(q) - 10).toString();
                    else 
                        r = q;
                }
            }
            */
        }

        //console.log('getQuota: ' + r);
        //setCurrentQuote(r);

        return r;
    }

    const getRegione = (value: any) => {
        if(value)
            return JSONRegions.italy_regions.filter(x => x.id_regione === value);
        else
            return JSONRegions.italy_regions;
    }
    const getProvincia = (sigla: any, id_regione: any) => {
        if(sigla)
            return JSONProvincies.italy_provincies.filter(x => x.sigla === sigla);
        else if (id_regione)
            return JSONProvincies.italy_provincies.filter(x => x.id_regione === id_regione);
        else
            return JSONProvincies.italy_provincies;
    }
    const getComune = (value: any) => {
        if(value)
            return JSONCities.italy_cities.filter(x => x.comune === value);
        else
            return JSONCities.italy_cities;
    }

    const decodeRegione = (value: any) => {
        let r = '';

        if(value) {
            let c = JSONRegions.italy_regions.find(x => x.id_regione === value);
            if(c)
                r = c?.regione;
        } 
      
        return r;
    }
    const decodeProvincia = (sigla: any, id_regione: any) => {
        let r = '';

        let p = undefined;
        if(sigla)
            p = JSONProvincies.italy_provincies.find(x => x.sigla === sigla);
        else if (id_regione)
            p = JSONProvincies.italy_provincies.find(x => x.id_regione === id_regione);
       
        if(p)
            r = p?.provincia;

        return r;
    }
    const decodeComune = (value: any) => {
        let r = '';

        if(value) {
            let c = JSONCities.italy_cities.find(x => x.istat === value);
            if(c)
               r = c?.comune;
        }
        
        return r;
    }



    function setCurrentTab(currentTab: string) {
        //console.log('setCurrentTab');
        sessionStorage.setItem('currentTab', JSON.stringify(currentTab));
    }
    function removeCurrentTab() {
        //console.log('removeCurrentTab');
        sessionStorage.removeItem('currentTab');
    }
    function getCurrentTab() : string | null {
        var k = sessionStorage.getItem('currentTab');
        if(k)
            return JSON.parse(k);
        else
            return null;
    }


    function setCurrentQuote(value: any) {
        //console.log('setCurrentQuote: ' + value);
        sessionStorage.setItem('currentQuote', JSON.stringify(value));
    }
    function removeCurrentQuote() {
        //console.log('removeCurrentQuote');
        sessionStorage.removeItem('currentQuote');
    }
    function getCurrentQuote(callback = '') : string | '0' {
        var k = sessionStorage.getItem('currentQuote');

        //console.log('getCurrentQuote: ' + callback + ' : ' + k);
        if(k)
            return JSON.parse(k) as string;
        else
            return '0';
    }
    //const currentQuote = JSON.parse(getCurrentQuote('auto')) as number;

    const getLastYearsOptions = (max: number) => {
        
        let y = moment().year();
        let r = [];
        
        r.push(y);
        for (let index = 0; index < max; index++) {
            r.push(y - (index + 1));
        }

        return r;

    };

    return {
        logArray,

        getCookieExpiration,
        getAge,
        getQuota,

        getRegione,
        getProvincia,
        getComune,

        setCurrentTab,
        getCurrentTab,
        removeCurrentTab,

        setCurrentQuote,
        getCurrentQuote,
        removeCurrentQuote,
        //currentQuote

        decodeRegione,
        decodeProvincia,
        decodeComune,

        getLastYearsOptions
    }
}
